import { db, auth } from './firebaseConfig'; // Import Firestore from your firebase configuration
import { collection, addDoc, query, where, getDocs, deleteDoc, doc, getDoc, updateDoc } from 'firebase/firestore'; // Import Firestore methods

// Function to load bookmarks for a specific user
export const loadBookmarks = async (user) => {
    const bookmarksCollection = collection(db, 'bookmarks');
    const q = query(bookmarksCollection, where('creatorId', '==', user.uid)); // Query for bookmarks by current user
    const querySnapshot = await getDocs(q);
    console.log("Query snapshot:", querySnapshot);
    const bookmarks = querySnapshot.docs.map(doc => ({  ...doc.data(), id: doc.id })); // Map to include document ID
    return bookmarks;
};

// Function to add a new bookmark
export const addBookmark = async (newBookmarkData) => {
    const bookmarksCollection = collection(db, 'bookmarks');
    const docRef = await addDoc(bookmarksCollection, newBookmarkData); // Add new bookmark to Firestore
    return { ...newBookmarkData, id: docRef.id }; // Return the new bookmark with its ID
};

// Function to delete a bookmark
export const deleteBookmark = async (id) => {
    try {
        console.log("id:", id);
        const currentUser = auth.currentUser;
        const bookmarkRef = doc(db, 'bookmarks', id);
        console.log("Document path:", bookmarkRef.path);
        // console.log("Current user ID:", currentUser?.uid);
        // // 先获取文档确认存在且属于当前用户
        const docSnap = await getDoc(bookmarkRef);
        // console.log('Attempting to delete document with ID:', id);
        console.log('Document snapshot:', docSnap);
        
        if (!docSnap.exists()) {
            console.log("Document does not exist. Document ID:", id);
            console.log("Document path:", bookmarkRef.path);
            throw new Error('document-not-found');
        }

        await deleteDoc(bookmarkRef);
        console.log("Document successfully deleted");
        return true;
    } catch (error) {
        console.error("Error deleting document: ", error);
        if (error.code === 'permission-denied') {
            console.error("Permission denied: User cannot delete this bookmark");
            // 在权限错误时也打印用户ID信息
            const currentUser = auth.currentUser;
            console.error("Current user ID during error:", currentUser?.uid);
        }
        console.error("Full error object:", JSON.stringify(error, null, 2));
        throw error;
    }
};

// 添加更新书签的函数
export const updateBookmark = async (id, bookmarkData) => {
    try {
        const bookmarkRef = doc(db, 'bookmarks', id);
        await updateDoc(bookmarkRef, bookmarkData);
        return { ...bookmarkData, id };
    } catch (error) {
        console.error("Error updating bookmark:", error);
        throw error;
    }
}; 